import { useTranslation } from 'react-i18next';

/**
 * The "OR" separator between an auth screen's primary form and its
 * alternative actions (social login, one-time code).
 */
const AuthDivider = () => {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <div className="relative flex justify-center">
        <span className="text-body-medium-regular bg-white px-2 text-gray-500 uppercase tracking-wide">
          {t('OR')}
        </span>
      </div>
    </div>
  );
};

export default AuthDivider;
